
    import Append from './AppendIcon.vue'
    import ArrowDownCircle from './ArrowDownCircle.vue'
    import ArrowRight from './ArrowRight.vue'
    import Atention from './AtentionIcon.vue'
    import Camera from './CameraIcon.vue'
    import Check from './CheckIcon.vue'
    import Checks from './ChecksIcon.vue'
    import CheckFill from './CheckIconFill.vue'
    import Copy from './CopyIcon.vue'
    import ChevronDown from './ChevronDown.vue'
    import Chat from './ChatIcon.vue'
    import Close from './CloseIcon.vue'
    import DotsHorizontal from './DotsHorizontal.vue'
    import DotsVertical from './DotsVertical.vue'
    import Loading from './LoadingIcon.vue'
    import LoadingCircle from './LoadingCircle.vue'
    import LoadingDots from './LoadingDots.vue'
    import Logout from './LogoutIcon.vue'
    import RotateClockWise from './RotateClockWise.vue'
    import Send from './SendIcon.vue'
    import Time from './TimeIcon.vue'
    import Moon from './MoonIcon.vue'
    import More from './MoreHorizontal.vue'
    import Search from './SearchIcon.vue'
    import Sun from './SunIcon.vue'
    import AirPlay from './AirPlay.vue'
    import Refresh from './RefreshCcw.vue'
    import Sort from './SortIcon.vue'
    import MessageSquare from './MessageSquare.vue'
    import SortDown from './SortDown.vue'
    import Attach from './AttachIcon.vue'
    import Microphone from './MicrophoneIcon.vue'
    import Play from './PlayIcon.vue'
    import RefreshAnimate from './RefreshAminate.vue'
    import Sad from './SadIcon.vue'
    import Loader from './LoaderIcon.vue'
    import User from './UserIcon.vue'
    import Users from './UsersIcon.vue'
    import File from './FileIcon.vue'
    import Image from './ImageIcon.vue'
    import ArrowLeft from './ArrowLeft.vue'
    import Plus from './PlusIcon.vue'
    import Music from './MusicIcon.vue'
    import Video from './VideoIcon.vue'
    import Folder from './FolderIcon.vue'
    import ExternalLink from './ExternalLink.vue'
    import Filter from './FilterIcon.vue'
    import UserCircle from './UserCircle.vue'
    import Happy from './HappyIcon.vue'
    import StarFilled from './StarFilled.vue'
    import VolumeOne from './VolumeOne.vue'
    import VolumeX from './VolumeX.vue'
    import ChevronRight from './ChevronRight.vue'
    import Trashed from './TrashIcon.vue'
    import CircleStop from './CircleStopIcon.vue'
    import Stop from './StopIcon.vue'
    import Circle from './CircleIcon.vue'
    import InformationCircle from './InformationCircleIcon.vue'
    import Print from './PrintIcon.vue'
    export default {
        components: {
            RefreshAnimate,
            Attach,
            Microphone,
            Play,
            Append,
            ArrowDownCircle,
            ArrowLeft,
            ArrowRight,
            Atention,
            Camera,
            Chat,
            Check,
            Checks,
            CheckFill,
            ChevronDown,
            Close,
            Copy,
            DotsHorizontal,
            DotsVertical,
            Loading,
            LoadingCircle,
            Logout,
            LoadingDots,
            RotateClockWise,
            Send,
            Time,
            Moon,
            More,
            Search,
            Sun,
            AirPlay,
            Refresh,
            Sort,
            MessageSquare,
            SortDown,
            Sad,
            Loader,
            User,
            Users,
            File,
            Image,
            Plus,
            Music,
            Video,
            Folder,
            ExternalLink,
            Filter,
            UserCircle,
            Happy,
            StarFilled,
            VolumeOne,
            VolumeX,
            ChevronRight,
            Trashed,
            CircleStop,
            Stop,
            Circle,
            InformationCircle,
            Print
        },
        props: {
            name: { type: String, required: true }
        }
    }
